import { render, staticRenderFns } from "./checkDate.vue?vue&type=template&id=2573d31b&scoped=true&"
import script from "./checkDate.vue?vue&type=script&lang=js&"
export * from "./checkDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573d31b",
  null
  
)

export default component.exports